import { useOIDCStore } from '@/stores/oidc.store'
import PortalView from '@/views/PortalView.vue'
import ZitadelLoginView from '@/views/auth/ZitadelLogin.vue'
import ZitadelLoginCallbackView from '@/views/auth/ZitadelLoginCallback.vue'
import CustomerProfileView from '@/views/core/CustomerProfileView.vue'
import CustomersView from '@/views/core/CustomersView.vue'
import TeamInvitationsView from '@/views/core/TeamInvitationsView.vue'
import TeamsView from '@/views/core/TeamsView.vue'
import LoadForecast from '@/views/cpm/LoadForecast.vue'
import TransmissionPeakView from '@/views/cpm/TransmissionPeakView.vue'
import BillEstimatesView from '@/views/eos/BillEstimatesView.vue'
import ChartsView from '@/views/eos/ChartsView.vue'
import PPAView from '@/views/eos/PPAView.vue'

import ProgramParticipation from '@/views/eos/demand-response/ProgramParticipation.vue'
import BRDTView from '@/views/eos/demand-response/BRDTView.vue'
import BaselineSimulation from '@/views/eos/demand-response/BaselineSimulation.vue'
import ReportsView from '@/views/eos/ReportsView.vue'
import TableView from '@/views/eos/TableView.vue'
import VisitorLogsView from '@/views/hvl/VisitorLogsView.vue'
import RepairRequestSubmissionsView from '@/views/rc/RepairRequestSubmissionsView.vue'
import WorkOrdersView from '@/views/rc/WorkOrdersView.vue'

import LegalDocumentsView from '@/views/core/LegalDocumentsView.vue'

import CustomerRSATable from '@/components/rc/tables/CustomerRSATable.vue'
import CustomerRepairRequestsTable from '@/components/rc/tables/CustomerRepairRequestsTable.vue'
import CustomerWorkOrdersTable from '@/components/rc/tables/CustomerWorkOrdersTable.vue'

import ShipmentsView from '@/views/rc/logistics/ShipmentsView.vue'
import ContainersView from '@/views/rc/logistics/containers/ContainersView.vue'
import ShipmentDetailsView from '@/views/rc/shipment-details/ShipmentDetailsView.vue'

import CustomerProfileAsicwDetails from '@/components/core/customers/CustomerProfileAsicwDetails.vue'
import CustomerProfileRCDetails from '@/components/core/customers/CustomerProfileRCDetails.vue'
import PolicyGroupsTable from '@/components/rc/tables/PolicyGroupsTable.vue'
import SitesView from '@/views/core/SitesView.vue'
import BillingTableView from '@/views/rc/BillingTableView.vue'
import SparePartsView from '@/views/rc/SparePartsView.vue'
import ContainerDetailsView from '@/views/rc/logistics/containers/ContainerDetailsView.vue'
import MinerRepairsView from '@/views/rc/miners/MinerRepairsView.vue'
import MinersDashboardView from '@/views/rc/miners/MinersDashboardView.vue'
import RepairActionsView from '@/views/rc/pricing/RepairActionsView.vue'
import ServicesView from '@/views/rc/pricing/ServicesView.vue'
import WorkOrderBilling from '@/views/rc/work-order-dashboard/WorkOrderBilling.vue'
import WorkOrderDashboardView from '@/views/rc/work-order-dashboard/WorkOrderDashboardView.vue'
import WorkOrderLogistics from '@/views/rc/work-order-dashboard/WorkOrderLogistics.vue'
import WorkOrderMiners from '@/views/rc/work-order-dashboard/WorkOrderMiners.vue'
import WorkOrderSummary from '@/views/rc/work-order-dashboard/WorkOrderSummary.vue'

import ClaimDetailsView from '@/components/asicw/claims/ClaimDetailsView.vue'
import ClaimsView from '@/views/asicw/ClaimsView.vue'
import AsicWPoliciesView from '@/views/asicw/PoliciesView.vue'
import PolicyGroupsView from '@/views/asicw/PolicyGroupsView.vue'
import AsicWPricingView from '@/views/asicw/PricingView.vue'

import AutoCurtailmentManagementView from '@/views/eos/auto-curtailment/AutoCurtailmentManagementView.vue'
import BillingInvoicedTable from '@/views/rc/billing/BillingInvoicedTable.vue'
import BillingUninvoicedTable from '@/views/rc/billing/BillingUninvoicedTable.vue'
import { createRouter, createWebHistory, type RouteRecordNameGeneric } from 'vue-router'

import ForemanConfigurationView from '@/views/core/ForemanConfigurationView.vue'
import CPMProgramManagementView from '@/views/cpm/CPMProgramManagementView.vue'
import CPMCustomerSavingsView from '@/views/cpm/CPMCustomerSavingsView.vue'
import ProgramSuccessView from '@/views/cpm/ProgramSuccessView.vue'
import SiteCurtailmentConfigurationView from '@/views/eos/auto-curtailment/SiteCurtailmentConfigurationView.vue'
import ClientsDowntimeSummaryView from '@/views/eos/downtimes/ClientsDowntimeSummaryView.vue'
import DowntimesView from '@/views/eos/downtimes/DowntimesView.vue'
import InfrastructureDowntimeSummaryView from '@/views/eos/downtimes/InfrastructureDowntimeSummaryView.vue'
import SiteDispatchesView from '@/views/eos/downtimes/SiteDispatchesView.vue'
import MinersDowntimeSummaryView from '@/views/eos/downtimes/infrastructure-summary/MinersDowntimeSummaryView.vue'
import RacksDowntimeSummaryView from '@/views/eos/downtimes/infrastructure-summary/RacksDowntimeSummaryView.vue'
import SitesDowntimeSummaryView from '@/views/eos/downtimes/infrastructure-summary/SitesDowntimeSummaryView.vue'
import StructuresDowntimeSummaryView from '@/views/eos/downtimes/infrastructure-summary/StructuresDowntimeSummaryView.vue'
import HostingClientsView from '@/views/eos/site-map/HostingClientsView.vue'
import SiteMapView from '@/views/eos/site-map/SiteMapView.vue'
import SiteMapMinersView from '@/views/eos/site-map/infrastructure/SiteMapMinersView.vue'
import SiteMapRacksView from '@/views/eos/site-map/infrastructure/SiteMapRacksView.vue'
import SiteMapStructuresView from '@/views/eos/site-map/infrastructure/SiteMapStructuresView.vue'
import LMPThresholdView from '@/views/eos/thresholds/LMPThresholdView.vue'
import NBPTThresholdsView from '@/views/eos/thresholds/NBPTThresholdsView.vue'
import EquipmentTypeView from '@/views/hvl/EquipmentTypeView.vue'
import EquipmentView from '@/views/hvl/EquipmentView.vue'
import HostedMinersView from '@/views/hvl/HostedMinersView.vue'
import WorkOrderChat from '@/views/rc/work-order-dashboard/WorkOrderChat.vue'
import { DateTime } from 'luxon'
import BalanceView from '@/views/asicw/BalanceSheetView.vue'
import InvoicesView from '@/views/asicw/ClaimInvoicesView.vue'
import PremiumInvoicesView from '@/views/asicw/PremiumInvoicesView.vue'
import DAPerformanceTrackingView from '@/views/eos/demand-response/DARTPerformanceTracking.vue'
import ORPerformanceTrackingView from '@/views/eos/demand-response/ORPerformanceTracking.vue'
import { loginAdminPortalUser } from '@/services/core.service'
import ProgramEarningsDashboard from '@/views/eos/demand-response/ProgramEarningsDashboard.vue'

const ASICW_CUSTOMER_PAGES: RouteRecordNameGeneric[] = [
  'asicw-policy-groups',
  'asicw-policies',
  'asicw-claims',
  'asicw-claims-details',
  'asicw-pricing',
]

const RCAPP_CUSTOMER_PAGES: RouteRecordNameGeneric[] = [
  'rc-spare-parts',
  'rc-work-orders',
  'rc-repair-request-submissions',
  'rc-work-order-dashboard-overview',
  'rc-work-order-dashboard-logistics',
  'rc-work-order-dashboard-miners',
  'rc-work-order-dashboard-billing',
  'rc-work-order-dashboard-chat',
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: ZitadelLoginView,
      beforeEnter: async () => {
        const oidcStore = useOIDCStore()
        if (!oidcStore.isInitialized) {
          oidcStore.init() // Don't await, otherwise this blocks the UI
        }
      },
    },
    {
      path: '/callback',
      name: 'callback',
      component: ZitadelLoginCallbackView,
      beforeEnter: async () => {
        const oidcStore = useOIDCStore()
        if (!oidcStore.isInitialized) {
          await oidcStore.init()
        }

        // If user is already fully logged in, redirect to root
        if (oidcStore.user && oidcStore.profile) {
          return { name: 'portal' }
        }

        oidcStore.signInCallback()
      },
    },
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: LegalDocumentsView,
      beforeEnter: () => {
        const { hasAcceptedLegalDocuments } = useOIDCStore()
        if (hasAcceptedLegalDocuments === false) {
          // User hasn't accepted legal documents, allow navigation
          return true
        }

        // User has already accepted, redirect to root
        return { name: 'portal', replace: true }
      },
    },
    {
      path: '/',
      name: 'portal',
      component: PortalView,
      beforeEnter: async (to) => {
        const oidcStore = useOIDCStore()

        // Ensure OIDC store is initialized
        if (!oidcStore.isInitialized) {
          await oidcStore.init()
        }

        // If user is not logged in, redirect to login page
        if (!oidcStore.user) return { name: 'login', replace: true }

        // Ensure user profile is loaded
        if (!oidcStore.profile) {
          await oidcStore.loadUserProfile()
        }

        const {
          profile,
          hasAcceptedLegalDocuments,
          isAdminUser,
          isEOSUser,
          isRCAppUser,
          isASICWAppUser,
          isHVLAppUser,
          isCustomer,
        } = oidcStore

        // If user has not accepted legal documents, redirect them there
        if (profile && hasAcceptedLegalDocuments === false) {
          return { name: 'terms-and-conditions' }
        }

        // Ensure user is logged into the admin portal backend
        await loginAdminPortalUser()

        // Route user to appropriate sub-app
        if (to.path === '/') {
          if (isEOSUser || isAdminUser) return { name: 'eos-table', replace: true }
          if (isRCAppUser) return { name: 'rc-work-orders', replace: true }
          if (isASICWAppUser) return { name: 'asicw-policies', replace: true }
          if (isHVLAppUser) return { name: 'hvl-visitor-logs', replace: true }
          if (isCustomer) return { name: 'rc-work-orders', replace: true }
        }
      },
      children: [
        {
          path: '/team',
          name: 'teams',
          component: TeamsView,
          meta: {
            name: 'My Team',
          },
          beforeEnter: () => {
            const { isCustomer } = useOIDCStore()
            if (!isCustomer) return { name: 'portal' }
          },
        },
        {
          path: '/team/invitations',
          name: 'team-invitations',
          component: TeamInvitationsView,
          meta: {
            name: 'Team Invitations',
          },
          beforeEnter: () => {
            const { isCustomer } = useOIDCStore()
            if (!isCustomer) return { name: 'portal' }
          },
        },
        {
          path: '/core',
          name: 'management',
          redirect: { name: 'core-customers' },
          beforeEnter: () => {
            const { isManagerUser } = useOIDCStore()
            if (!isManagerUser) return { name: 'portal' }
          },
          children: [
            {
              path: 'sites',
              name: 'core-sites',
              component: SitesView,
              meta: {
                name: 'Sites',
              },
            },
            {
              path: 'customers',
              name: 'core-customers',
              component: CustomersView,
              meta: {
                name: 'Customers',
              },
            },
            {
              path: 'foreman-configuration',
              name: 'core-foreman-configuration',
              component: ForemanConfigurationView,
              meta: {
                name: 'Foreman Configuration',
              },
            },
            {
              path: 'customers/:customerId',
              name: 'core-customer-profile',
              redirect: { name: 'rc-customer-work-orders' },
              component: CustomerProfileView,
              props: (route) => ({ customerId: Number(route.params.customerId) }),
              meta: {
                name: 'Customer Profile',
              },
              children: [
                {
                  path: 'rc',
                  name: 'rc-customer',
                  props: (route) => ({ customerId: Number(route.params.customerId) }),
                  redirect: { name: 'rc-customer-work-orders' },
                  component: CustomerProfileRCDetails,
                  children: [
                    {
                      path: 'work-orders',
                      name: 'rc-customer-work-orders',
                      component: CustomerWorkOrdersTable,
                      props: (route) => ({ customerId: Number(route.params.customerId) }),
                    },
                    {
                      path: 'rsas',
                      name: 'rc-customer-rsas',
                      component: CustomerRSATable,
                      props: (route) => ({ customerId: Number(route.params.customerId) }),
                    },
                    {
                      path: 'repair-requests',
                      name: 'rc-customer-repair-requests',
                      component: CustomerRepairRequestsTable,
                      props: (route) => ({ customerId: Number(route.params.customerId) }),
                    },
                  ],
                },
                {
                  path: 'asicw',
                  name: 'asicw-customer',
                  redirect: { name: 'asicw-customer-policy-groups' },
                  component: CustomerProfileAsicwDetails,
                  props: (route) => ({ customerId: Number(route.params.customerId) }),
                  children: [
                    {
                      path: 'policy-groups',
                      name: 'asicw-customer-policy-groups',
                      component: PolicyGroupsTable,
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: '/hvl',
          name: 'hvl',
          redirect: { name: 'hvl-visitor-logs' },
          beforeEnter: () => {
            const { isHVLAppUser } = useOIDCStore()
            if (!isHVLAppUser) return { name: 'portal' }
          },
          children: [
            {
              path: 'visitor-logs',
              name: 'hvl-visitor-logs',
              component: VisitorLogsView,
              meta: {
                name: 'Visitor Logs',
              },
            },
            {
              path: 'hosted-miners',
              name: 'hvl-hosted-miners',
              component: HostedMinersView,
              meta: {
                name: 'Hosted Miners',
              },
            },
            {
              path: 'equipment-types',
              name: 'hvl-equipment-types',
              component: EquipmentTypeView,
              meta: {
                name: 'Equipment Types',
              },
            },
            {
              path: 'equipment',
              name: 'hvl-equipment',
              component: EquipmentView,
              meta: {
                name: 'Equipment',
              },
            },
          ],
        },
        {
          path: '/rc',
          name: 'rc',
          redirect: { name: 'rc-work-orders' },
          beforeEnter: (to) => {
            const { isRCAppUser, isCustomer } = useOIDCStore()
            if (!isRCAppUser && !isCustomer) return { name: 'portal' }

            if (isCustomer && !RCAPP_CUSTOMER_PAGES.includes(to.name)) return { name: 'rc', replace: true }
          },
          children: [
            {
              path: 'repair-request-submissions',
              name: 'rc-repair-request-submissions',
              component: RepairRequestSubmissionsView,
              meta: {
                name: 'Repair Request Submissions',
              },
            },
            {
              path: 'billing',
              name: 'rc-billing',
              component: BillingTableView,
              meta: {
                name: 'Billing',
              },
              redirect: { name: 'rc-billing-uninvoiced' },
              props: true,
              children: [
                {
                  path: 'uninvoiced',
                  name: 'rc-billing-uninvoiced',
                  component: BillingUninvoicedTable,
                },
                {
                  path: 'invoiced',
                  name: 'rc-billing-invoiced',
                  component: BillingInvoicedTable,
                },
              ],
            },
            {
              path: 'work-orders',
              name: 'rc-work-orders',
              component: WorkOrdersView,
              meta: {
                name: 'Work Orders',
              },
            },
            {
              path: 'spare-parts',
              name: 'rc-spare-parts',
              component: SparePartsView,
              meta: {
                name: 'Spare Parts',
              },
            },
            {
              path: 'pricing',
              name: 'rc-pricing',
              redirect: { name: 'rc-pricing-services' },
              children: [
                {
                  path: 'services',
                  name: 'rc-pricing-services',
                  component: ServicesView,
                  meta: {
                    name: 'Services',
                  },
                },
                {
                  path: 'repair-charges',
                  name: 'rc-pricing-repair-actions',
                  component: RepairActionsView,
                  meta: {
                    name: 'Repair Charges',
                  },
                },
              ],
            },
            {
              path: 'logistics',
              name: 'rc-logistics',
              redirect: { name: 'rc-logistics-shipments' },
              children: [
                {
                  path: 'shipments',
                  name: 'rc-logistics-shipments',
                  component: ShipmentsView,
                  meta: {
                    name: 'Shipments',
                  },
                },
                {
                  path: 'shipments/:shipmentId',
                  name: 'rc-logistics-shipment-details',
                  component: ShipmentDetailsView,
                  props: (route) => ({
                    shipmentId: Number(route.params.shipmentId),
                  }),
                  meta: {
                    name: 'Shipment Details',
                  },
                },
                {
                  path: 'containers',
                  name: 'rc-logistics-containers',
                  component: ContainersView,
                  meta: {
                    name: 'Containers',
                  },
                },
                {
                  path: 'containers/:containerID',
                  name: 'rc-logistics-container-details',
                  component: ContainerDetailsView,
                  props: (route) => ({
                    containerID: Number(route.params.containerID),
                  }),
                  meta: {
                    name: 'Container Details',
                  },
                },
              ],
            },
            {
              path: 'miners',
              name: 'rc-miners',
              redirect: { name: 'rc-miners-dashboard' },
              children: [
                {
                  path: 'dashboard',
                  name: 'rc-miners-dashboard',
                  component: MinersDashboardView,
                  meta: {
                    name: 'Miners Dashboard',
                  },
                },
                {
                  path: ':minerId',
                  name: 'rc-miner-repairs',
                  meta: {
                    name: 'Miner Repairs',
                  },
                  component: MinerRepairsView,
                  // Define the type of the route parameter as a number
                  props: (route) => ({ minerId: Number(route.params.minerId) }),
                },
              ],
            },
            {
              path: 'work-orders/:number',
              name: 'rc-work-order-dashboard',
              meta: {
                name: 'Work Order Dashboard',
              },
              redirect: { name: 'rc-work-order-dashboard-overview' },
              component: WorkOrderDashboardView,
              props: true,
              children: [
                {
                  path: 'overview',
                  name: 'rc-work-order-dashboard-overview',
                  component: WorkOrderSummary,
                  props: true,
                },
                {
                  path: 'logistics',
                  name: 'rc-work-order-dashboard-logistics',
                  component: WorkOrderLogistics,
                  props: true,
                },
                {
                  path: 'miners',
                  name: 'rc-work-order-dashboard-miners',
                  component: WorkOrderMiners,
                  props: true,
                },
                {
                  path: 'billing',
                  name: 'rc-work-order-dashboard-billing',
                  component: WorkOrderBilling,
                  props: true,
                },
                {
                  path: 'chat',
                  name: 'rc-work-order-dashboard-chat',
                  component: WorkOrderChat,
                  props: true,
                },
              ],
            },
          ],
        },
        {
          path: '/asicw',
          name: 'asicw',
          redirect: { name: 'asicw-policies' },
          beforeEnter: (to) => {
            const { isASICWAppUser, isCustomer } = useOIDCStore()
            if (!isASICWAppUser && !isCustomer) return { name: 'portal' }
            if (isCustomer && !ASICW_CUSTOMER_PAGES.includes(to.name)) return { name: 'asicw', replace: true }
          },
          children: [
            {
              path: 'policy-groups',
              name: 'asicw-policy-groups',
              component: PolicyGroupsView,
              meta: {
                name: 'Policy Groups',
              },
            },
            {
              path: 'policies',
              name: 'asicw-policies',
              component: AsicWPoliciesView,
              meta: {
                name: 'Policies',
              },
            },
            {
              path: 'pricing',
              name: 'asicw-pricing',
              component: AsicWPricingView,
              meta: {
                name: 'Pricing',
              },
            },
            {
              path: 'claims',
              name: 'asicw-claims',
              component: ClaimsView,
              meta: {
                name: 'Claims',
              },
            },
            {
              path: 'claims/:claimNumber',
              name: 'asicw-claims-details',
              component: ClaimDetailsView,
              props: (route) => ({
                claimNumber: String(route.params.claimNumber),
              }),
              meta: {
                name: 'Claim Details',
              },
            },
            {
              path: 'claim-invoices',
              name: 'asicw-claim-invoices',
              component: InvoicesView,
              meta: {
                name: 'Claim Invoices',
              },
            },
            {
              path: 'premium-invoices',
              name: 'asicw-premium-invoices',
              component: PremiumInvoicesView,
              meta: {
                name: 'Premium Invoices',
              },
            },
            {
              path: 'balance-sheet',
              name: 'asicw-balance-sheet',
              component: BalanceView,
              meta: {
                name: 'Balance Sheet',
              },
            },
          ],
        },
        {
          path: '/cpm',
          name: 'cpm',
          redirect: { name: 'cpm-load-forecast' },
          beforeEnter: () => {
            const { isEOSUser, isCustomer } = useOIDCStore()
            if (!isEOSUser || isCustomer) return { name: 'portal' }
          },
          children: [
            {
              path: 'load-forecast',
              name: 'cpm-load-forecast',
              component: LoadForecast,
              meta: {
                name: 'Load Forecast',
              },
            },
            {
              path: 'transmission-peak',
              name: 'cpm-transmission-peak',
              component: TransmissionPeakView,
              meta: {
                name: 'Transmission Peak',
              },
            },
            {
              path: 'program-management',
              name: 'cpm-program-management',
              component: CPMProgramManagementView,
              meta: {
                name: 'CP Program Management',
              },
            },
            {
              path: 'customer-savings',
              name: 'cpm-customer-savings',
              component: CPMCustomerSavingsView,
              meta: {
                name: 'Customer Savings',
              },
            },
            {
              path: 'program-success',
              name: 'cpm-program-success',
              component: ProgramSuccessView,
              meta: {
                name: 'CPM Program Success',
              },
            },
          ],
        },
        {
          path: '/eos',
          name: 'eos',
          redirect: { name: 'eos-table' },
          beforeEnter: () => {
            const { isEOSUser } = useOIDCStore()
            if (!isEOSUser) return { name: 'portal' }
          },
          children: [
            {
              path: 'reports',
              name: 'eos-reports',
              component: ReportsView,
              meta: {
                name: 'Reports',
              },
            },
            {
              path: 'table',
              name: 'eos-table',
              component: TableView,
              meta: {
                name: 'Table',
              },
            },
            {
              path: 'charts',
              name: 'eos-charts',
              component: ChartsView,
              meta: {
                name: 'Charts',
              },
            },
            {
              path: 'ppa',
              name: 'eos-ppa',
              component: PPAView,
              meta: {
                name: 'Power Purchase Agreements',
              },
            },
            {
              path: 'demand-response',
              name: 'demand-response',
              redirect: { name: 'eos-brdt' },
              children: [
                {
                  path: 'program-participation',
                  name: 'program-participation',
                  component: ProgramParticipation,
                  meta: {
                    name: 'Program Participation',
                  },
                },
                {
                  path: 'program-earnings',
                  name: 'program-earnings',
                  component: ProgramEarningsDashboard,
                  meta: {
                    name: 'MISO Energy Programs Earnings',
                  },
                },
                {
                  path: 'baseline-reset-days-tracker',
                  name: 'eos-brdt',
                  component: BRDTView,
                  meta: {
                    name: 'Baseline Reset Days Tracker',
                    description: 'Find out the next forced baseline reset day depending on your prior activity.',
                  },
                },
                {
                  path: 'da-pr-performance-tracker',
                  name: 'da-pr-performance-tracker',
                  component: DAPerformanceTrackingView,
                  meta: {
                    name: 'DA PR Performance Tracker',
                  },
                },
                {
                  path: 'or-performance-tracker',
                  name: 'or-performance-tracker',
                  component: ORPerformanceTrackingView,
                  meta: {
                    name: 'Operating Reserves Performance Tracker',
                  },
                },
                {
                  path: 'baseline-simulator',
                  name: 'eos-baseline-simulator',
                  component: BaselineSimulation,
                  meta: {
                    name: 'Baseline Simulator',
                    description: 'Simulate baseline calculation for a specific site and day',
                  },
                },
              ],
            },
            {
              path: 'thresholds',
              name: 'eos-thresholds',
              redirect: { name: 'eos-lmp-thresholds' },
              children: [
                {
                  path: 'lmp',
                  name: 'eos-lmp-thresholds',
                  component: LMPThresholdView,
                  meta: {
                    name: 'LMP Thresholds',
                  },
                },
                {
                  path: 'nbpt',
                  name: 'eos-nbpt-thresholds',
                  component: NBPTThresholdsView,
                  meta: {
                    name: 'NBPT Thresholds',
                  },
                },
              ],
            },
            {
              path: 'bill-estimates',
              name: 'eos-bill-estimates',
              component: BillEstimatesView,
              meta: {
                name: 'Billing',
              },
            },
            {
              path: 'auto-curtailments',
              name: 'eos-auto-curtailments',
              redirect: { name: 'eos-auto-curtailment-variables' },
              children: [
                {
                  path: 'variables',
                  name: 'eos-auto-curtailment-variables',
                  component: AutoCurtailmentManagementView,
                  meta: {
                    name: 'RT LMP Auto Curtailment Management',
                  },
                },
                {
                  path: 'site-curtailment-configurations',
                  name: 'eos-site-curtailment-configurations',
                  component: SiteCurtailmentConfigurationView,
                  meta: {
                    name: 'Site Curtailment Configurations',
                  },
                },
              ],
            },
            {
              path: 'site-map',
              name: 'eos-site-map',
              meta: {
                name: 'Site Map',
              },
              redirect: { name: 'eos-site-map-structures' },
              component: SiteMapView,
              props: true,
              children: [
                {
                  path: 'structures',
                  name: 'eos-site-map-structures',
                  component: SiteMapStructuresView,
                  props: true,
                },
                {
                  path: 'racks',
                  name: 'eos-site-map-racks',
                  component: SiteMapRacksView,
                  props: true,
                },
                {
                  path: 'miners',
                  name: 'eos-site-map-miners',
                  component: SiteMapMinersView,
                  props: true,
                },
              ],
            },
            {
              path: 'hosting-clients',
              name: 'eos-hosting-clients',
              component: HostingClientsView,
              meta: {
                name: 'Hosting Clients',
              },
            },
            {
              path: 'downtime',
              name: 'eos-downtime',
              redirect: { name: 'eos-downtime-client-summary' },
              children: [
                {
                  path: 'events',
                  name: 'eos-downtime-events',
                  component: DowntimesView,
                  meta: {
                    name: 'Downtime Events',
                  },
                },
                {
                  path: 'client-summary',
                  name: 'eos-downtime-client-summary',
                  component: ClientsDowntimeSummaryView,
                  meta: {
                    name: 'Client Summary',
                  },
                },
                {
                  path: 'infrastructure-summary',
                  name: 'eos-downtime-infrastructure-summary',
                  component: InfrastructureDowntimeSummaryView,
                  redirect: {
                    name: 'eos-downtime-sites-downtime-summary',
                    query: {
                      start_date: DateTime.now().startOf('month').toISO(),
                      end_date: DateTime.now().endOf('month').toISO(),
                    },
                  },
                  meta: {
                    name: 'Infrastructure Summary',
                  },
                  children: [
                    {
                      path: 'sites',
                      name: 'eos-downtime-sites-downtime-summary',
                      component: SitesDowntimeSummaryView,
                    },
                    {
                      path: 'structures',
                      name: 'eos-downtime-structures-downtime-summary',
                      component: StructuresDowntimeSummaryView,
                    },
                    {
                      path: 'racks',
                      name: 'eos-downtime-racks-downtime-summary',
                      component: RacksDowntimeSummaryView,
                    },
                    {
                      path: 'miners',
                      name: 'eos-downtime-miners-downtime-summary',
                      component: MinersDowntimeSummaryView,
                    },
                  ],
                },
                {
                  path: 'site-dispatch',
                  name: 'eos-downtime-site-dispatch',
                  component: SiteDispatchesView,
                  meta: {
                    name: 'Site Dispatch',
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/',
    },
  ],
  linkActiveClass: 'active',
})

export default router
